import CommandeLigneController from './commande.ligne.controller';
import Template from './commande.ligne.html';

export default {
	bindings: {
		index: '=',
		groupe: '=',
		scl: '=',
		commande: '=',
		chantierid: '=',
		recalculeLignes: '&',
		hasTransport: '='
	},
	template: Template,
	controller: CommandeLigneController
};
